module.exports = __webpack_public_path__ + "img/Group 3_white.348c444b.svg";